














































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import scrollBar from "./scrollBar.vue";
import iconbutton from "./iconButtons.vue";
import dropdownMenu from "./dropdownMenu.vue";
import gButton from "./button.vue";
import ripple from "./ripple.vue";
import search,{ SearchRes } from "./search.vue";
import toggle from "./toggle.vue";
import tooltip from "./tooltip.vue";
import inlineTextEdit from "./inlineTextEdit.vue";
import dateSelector from "./dateSelector.vue";
import multilineTextEdit from "./multiLineEdit.vue";
import popupmenu, {PopupMenuItem} from "./popupMenu.vue";
import { POINT_CONVERSION_COMPRESSED } from "constants";
import moment,{ weekdays, Moment } from "moment";

import {frontendClient} from "../lib/client";

import { nextTick } from "process";
import { setTimeout } from "timers";

@Component({
    components: {
        ripple,
        tooltip,
        dateSelector,
        search,
        toggle,
        dropdownMenu,
        iconbutton,
        gButton,
        popupmenu,
        inlineTextEdit,
        multilineTextEdit,
        scrollBar
    }
})

export default class ItemPrompt extends Vue {

    @Prop({}) promptVariant:any;
    @Prop({}) visible:boolean;
    @Prop({}) object:any;

    fromSelector:boolean = false;
    toSelector:boolean = false;

    item = null;
    isVisible=true;
    accessibility = null;
    promptHeight:number = null;
    loading:boolean = false;
    error:string=null;

    editableObject:any = null;
    newEditable:any = null;

    toggles : {
        1: boolean,
        2: boolean,
        3: boolean,
        4: boolean,
        5: boolean,
    } = {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false
    }

    groupsAttached : [
        {
            name:string,
            icon?:string,
            style?: string,
            function?: any,
            value?: string,
        }
    ] = [{
        name: "No group selected",
    }]

    adminOfGroups : {
        name:string,
        icon?:string,
        style?: string,
        function?: any,
        value?: string,
    }[] = [];

    pagesInView:number = 1;
    groupUsers = null;
    groupDetails: {
        isAdmin: boolean,
        createdAt: string,
        updatedAt: string,
        name: string,
    } = null;

    openFromSelector(x?){
        this.fromSelector = true;
    }
    openToSelector(x?){
        this.toSelector = true;
    }
    closeFrom(x?){
        this.fromSelector = false;
    }
    closeTo(x?){
        this.toSelector = false;
    }
    closeRanges(){
        this.fromSelector = false;
        this.toSelector = false;
    }

    mounted(){
        this.initiatePrompt();
        this.newEditable = null;
        this.editableObject = null;
        this.determineObject();
    }

    determineObject(){
        if(this.object){
            this.newEditable = JSON.parse(JSON.stringify(this.object));
            this.editableObject = this.object;
        }
    }

    initiatePrompt(){
        this.scrollBarInit();
        this.isVisible = this.visible;
    }

    scrollBarInit(){
        nextTick(() => {
            (this.$refs.scrollBar as scrollBar).mountScrollable(this.$refs.scrollable as HTMLDivElement);
            this.adjustScrollbarReferenceHeight();
        })
    }

    adjustScrollbarReferenceHeight(){
        nextTick(() => {
            this.promptHeight = (this.$refs.scrollable as HTMLDivElement).scrollHeight;
        })
    }

    saveForm(){
        this.loading=true;
        this.error = null;

        if(this.editableObject) {
            this.editableObject = Object.assign(this.editableObject,this.newEditable);
        }

        if(this.promptVariant == "job"){
            if(isNaN(parseInt((this.$refs.letters as HTMLInputElement).value))){
                setTimeout(() => {
                    frontendClient.giveError("'Letters' must be a number");
                    this.loading = false;
                },0);
                return;
            }
            // REMOVED AS OF 21/06/20 - BTO OFFICE REQUEST 
            // to remove totalCost from job parameters --> removing checks and setting value to 0 as default
            // if(isNaN(parseInt((this.$refs.totalCost as HTMLInputElement).value))){
            //     setTimeout(() => {
            //         frontendClient.giveError("'Cost' must be a number");
            //         this.loading = false;
            //     },0);
            //     return;
            // }

            if(!this.editableObject){
                frontendClient.postEx('jobs/new', {
                    distributionName: (this.$refs.name as HTMLInputElement).value.trim(),
                    clientName: (this.$refs.client as HTMLInputElement).value.trim(),
                    pointOfContact: (this.$refs.attention as HTMLInputElement).value.trim(),

                    description: (this.$refs.description as HTMLInputElement).value.trim(),
                    location: (this.$refs.location as HTMLInputElement).value.trim(),

                    // TODO: parse date
                    startsAt: moment((this.$refs.startDate as HTMLInputElement).value, 'DD/MM/YYYY').toDate().getTime(),
                    endsAt: moment((this.$refs.endDate as HTMLInputElement).value, 'DD/MM/YYYY').toDate().getTime(),
                    letters: parseInt((this.$refs.letters as HTMLInputElement).value.trim()),

                    // purchaseOrderNumber: (this.$refs.purchaseOrderNumber as HTMLInputElement).value.trim(), REMOVED AS OF 21/06/20 - BTO request
                    purchaseOrderNumber: "0",
                    // totalCost: parseInt((this.$refs.totalCost as HTMLInputElement).value.trim()),  REMOVED AS OF 21/06/20 - BTO request
                    totalCost: 0,                    

                    complete: false,
                    color: "",
                }).then(() => {
                    this.loading = false;
                    this.closePrompt();
                    frontendClient.giveError("Job created")
                    setTimeout(() => {
                        frontendClient.clearError()
                    },1000);
                }).catch((err) => {
                    frontendClient.giveError("Issue when creating Job");
                })
            }else{
                frontendClient.postEx('jobs/edit', {
                    id: this.editableObject.id,

                    distributionName: (this.$refs.name as HTMLInputElement).value.trim(),
                    clientName: (this.$refs.client as HTMLInputElement).value.trim(),
                    pointOfContact: (this.$refs.attention as HTMLInputElement).value.trim(),

                    description: (this.$refs.description as HTMLInputElement).value.trim(),
                    location: (this.$refs.location as HTMLInputElement).value.trim(),
                    letters: parseInt((this.$refs.letters as HTMLInputElement).value.trim()),

                    purchaseOrderNumber: (this.$refs.purchaseOrderNumber as HTMLInputElement).value.trim(),
                    totalCost: parseInt((this.$refs.totalCost as HTMLInputElement).value.trim()),
                }).then(() => {
                    this.loading = false;
                    this.closePrompt();
                    frontendClient.giveError("Job edited")
                    setTimeout(() => {
                        frontendClient.clearError()
                    },1000);
                }).catch((err) => {
                    frontendClient.giveError("Issue when editing Job");
                })
            }
            
        }
        else if(this.promptVariant == "walker") {
            // new walker
            if(((this.$refs.emailAddress as HTMLInputElement).value).length > 0){
                let filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if(!filter.test((this.$refs.emailAddress as HTMLInputElement).value)){
                    setTimeout(() => {
                        frontendClient.giveError("Email invalid");
                        this.loading = false;
                    },0);
                    return;
                }
            }

            if(!this.editableObject){
                frontendClient.postEx('walkers/new', {
                    username: (this.$refs.username as HTMLInputElement).value.trim(),
                    password: (this.$refs.password as HTMLInputElement).value.trim(),

                    firstName: (this.$refs.firstName as HTMLInputElement).value.trim(),
                    lastName: (this.$refs.lastName as HTMLInputElement).value.trim(),

                    phoneNumber: (this.$refs.phoneNumber as HTMLInputElement).value.trim(),
                    emailAddress: (this.$refs.emailAddress as HTMLInputElement).value.trim(),
                }).then(() => {
                    this.loading = false;
                    this.closePrompt();
                    frontendClient.giveError("Walker created");
                    setTimeout(() => {
                        frontendClient.clearError()
                    },1000);
                }).catch((err) => {
                    frontendClient.giveError("Issue when creating walker");
                })
            }else{
                frontendClient.postEx('walkers/edit', {
                    id: this.editableObject.id, 
 
                    username: (this.$refs.username as HTMLInputElement).value,
                    password: (this.$refs.password as HTMLInputElement).value,

                    firstName: (this.$refs.firstName as HTMLInputElement).value,
                    lastName: (this.$refs.lastName as HTMLInputElement).value,

                    phoneNumber: (this.$refs.phoneNumber as HTMLInputElement).value,
                    emailAddress: (this.$refs.emailAddress as HTMLInputElement).value,
                }).then(() => {
                    this.loading = false;
                    this.closePrompt();
                    frontendClient.giveError("Walker edited");
                    setTimeout(() => {
                        frontendClient.clearError()
                    },1000);
                }).catch((err) => {
                    frontendClient.giveError(err);
                })
            }

        }else if(this.promptVariant == "password") {

            frontendClient.postEx('auth/changepassword', {
                oldPassword: (this.$refs.oldpw as HTMLInputElement).value, 
                newPassword: (this.$refs.newpw as HTMLInputElement).value,
            }).then(() => {
                this.loading = false;
                this.closePrompt();
                frontendClient.giveError("Password updated");
                setTimeout(() => {
                    frontendClient.clearError()
                },1000);
            }).catch((err) => {
                frontendClient.giveError(err);
            })
            
        }else if(this.promptVariant == "alert") {
            if(!this.editableObject){
                frontendClient.postEx('alerts/new', {
                    title: (this.$refs.alertTitle as HTMLInputElement).value.trim(),
                    body: (this.$refs.alertBody as HTMLInputElement).value.trim(),
                }).then(() => {
                    this.loading = false;
                    this.closePrompt();
                    frontendClient.giveError("Alert created");
                    setTimeout(() => {
                        frontendClient.clearError()
                    },1000);
                }).catch((err) => {
                    frontendClient.giveError("Issue when creating alert");
                })
            }else{
                frontendClient.postEx('alerts/edit', {
                    id: this.editableObject.id,
                    title: (this.$refs.alertTitle as HTMLInputElement).value.trim(),
                    body: (this.$refs.alertBody as HTMLInputElement).value.trim(),
                    isActive: true,
                }).then(() => {
                    this.loading = false;
                    this.closePrompt();
                    frontendClient.giveError("Alert edited");
                    setTimeout(() => {
                        frontendClient.clearError()
                    },1000);
                }).catch((err) => {
                    frontendClient.giveError("Issue when editing alert");
                })
            }
        }
    }

    closePrompt(event?) {
        this.$emit('closed'); // 2nd param is some value to pass with it
        this.adjustScrollbarReferenceHeight();
        this.editableObject = null;
    }

    @Watch('visible')
    toggleDisplay(to, from){
        this.isVisible = this.visible;
        this.scrollBarInit();
        this.adjustScrollbarReferenceHeight();
    }
    @Watch('referenceIdentifier')
    updateReference(to, from){
        this.initiatePrompt();
    }
}

